import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
// További oldalak importálása...

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-900 flex flex-col">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/szolgaltatasok" element={<Services />} />
          <Route path="/kapcsolat" element={<Contact />} />
          <Route path="/adatvedelem" element={<Privacy />} />
          {/* További route-ok... */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
